import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCloudBackupAndRecovery = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-cloud-backup-and-recovery';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.52 3.282a5.74 5.74 0 0 0-4.598 3.043c-.305.58-.446 1.01-.625 1.905-.012.058-.048.09-.099.09-.362 0-1.258.285-1.83.581-1.572.815-2.643 2.245-3.011 4.019-.115.558-.127 1.525-.024 2.08.146.786.488 1.607.957 2.291.246.36.792.948 1.096 1.182l.165.127.449-.599.448-.6-.134-.108c-.386-.312-.799-.824-1.057-1.309-1.128-2.119-.283-4.718 1.883-5.794.63-.312 1.188-.43 2.05-.43h.57v-.57c0-.862.118-1.42.43-2.05a4.22 4.22 0 0 1 1.95-1.95 3.8 3.8 0 0 1 1.122-.367 4.247 4.247 0 0 1 4.918 3.458c.034.194.06.582.06.909v.57h.57c.849 0 1.429.122 2.05.43a4.22 4.22 0 0 1 1.95 1.95c.859 1.73.402 3.855-1.103 5.133l-.153.13.448.6c.396.528.456.593.513.547.557-.457.927-.855 1.277-1.376.394-.586.74-1.445.875-2.174.103-.555.091-1.522-.024-2.08-.244-1.174-.77-2.161-1.588-2.976-.793-.791-1.814-1.348-2.863-1.561a3 3 0 0 0-.39-.063c-.051 0-.087-.032-.099-.09-.179-.895-.32-1.325-.625-1.905a5.5 5.5 0 0 0-1.023-1.381 5.69 5.69 0 0 0-4.535-1.662M7.08 12.86l-1.9 1.9h3.06V19h1.52v-4.24h3.06l-1.9-1.9A131 131 0 0 0 9 10.96c-.011 0-.875.855-1.92 1.9m7.16 1.26v2.12h-3.06l1.91 1.91L15 20.06l1.91-1.91 1.91-1.91h-3.06V12h-1.52z"
    })
  }));
});
export default SvgCloudBackupAndRecovery;